import React, { useEffect, useState, useRef } from 'react';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function NewsfilateHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <header className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-sm border-b border-gray-100" data-id="element-428">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-429">
        <div className="flex items-center justify-between h-16" data-id="element-430">
          <div className="flex items-center" data-id="element-431">
            <a href="#" className="flex-shrink-0" data-id="element-432">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/debbab01-79d9-49e0-a766-2a2a9aeb34ad/Nf_final.png" alt="Newsfiliate Logo" className="h-8" data-id="element-433" />
            </a>
          </div>
          <nav className="hidden md:flex space-x-8" data-id="element-434">
            <a href="#features" className="text-gray-600 hover:text-gray-900 font-medium" onClick={e => scrollToSection(e, 'features')} data-id="element-435">
              Features
            </a>
            <a href="#demo" className="text-gray-600 hover:text-gray-900 font-medium" onClick={e => scrollToSection(e, 'demo')} data-id="element-436">
              Demo
            </a>
            <a href="#pricing" className="text-gray-600 hover:text-gray-900 font-medium" onClick={e => scrollToSection(e, 'pricing')} data-id="element-437">
              Pricing
            </a>
            <div className="relative" ref={dropdownRef} data-id="element-438">
              <button className="text-gray-600 hover:text-gray-900 font-medium flex items-center" onClick={() => setIsDropdownOpen(!isDropdownOpen)} onMouseEnter={() => setIsDropdownOpen(true)} data-id="element-439">
                Create a List
                <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-440" />
              </button>
              {isDropdownOpen && <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg py-2 z-50 border border-gray-100" onMouseLeave={() => setIsDropdownOpen(false)} data-id="element-441">
                  <div className="px-4 py-2 text-sm text-gray-600" data-id="element-442">
                    Already install the app on Kit? Head over to the Newsfiliate
                    App to Create a List
                  </div>
                  <div className="border-t border-gray-100 my-2" data-id="element-443"></div>
                  <a href="https://datadyno.co/deals/creator?utm_source=lp" className="block px-4 py-2 text-sm text-[#5e60ce] font-medium hover:bg-gray-50" target="_blank" rel="noopener noreferrer" data-id="element-444">
                    Launch Newsfiliate App
                  </a>
                </div>}
            </div>
            <Link to="/" className="text-gray-600 hover:text-gray-900 font-medium" data-id="element-445">
              Creator Boost
            </Link>
          </nav>
          <div className="flex items-center" data-id="element-446">
            <a href="https://app.kit.com/apps/1229" className="hidden md:inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5e60ce]" style={{
            backgroundColor: '#5e60ce'
          }} target="_blank" rel="noopener noreferrer" data-id="element-447">
              Install on Kit
            </a>
            <button className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-448">
              {isMenuOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-449" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-450" />}
            </button>
          </div>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden py-4 border-t border-gray-100" data-id="element-451">
            <div className="flex flex-col space-y-4" data-id="element-452">
              <a href="#features" className="text-gray-600 hover:text-gray-900 font-medium px-2 py-1" onClick={e => scrollToSection(e, 'features')} data-id="element-453">
                Features
              </a>
              <a href="#demo" className="text-gray-600 hover:text-gray-900 font-medium px-2 py-1" onClick={e => scrollToSection(e, 'demo')} data-id="element-454">
                Demo
              </a>
              <a href="#pricing" className="text-gray-600 hover:text-gray-900 font-medium px-2 py-1" onClick={e => scrollToSection(e, 'pricing')} data-id="element-455">
                Pricing
              </a>
              <div className="px-2 py-1" data-id="element-456">
                <button className="text-gray-600 hover:text-gray-900 font-medium flex items-center" onClick={() => setIsDropdownOpen(!isDropdownOpen)} data-id="element-457">
                  Create a List
                  <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-458" />
                </button>
                {isDropdownOpen && <div className="ml-4 mt-2 space-y-2" data-id="element-459">
                    <div className="text-sm text-gray-600" data-id="element-460">
                      Already install the app on Kit? Head over to the
                      Newsfiliate App to Create a List
                    </div>
                    <a href="https://datadyno.co/deals/creator?utm_source=lp" className="block text-sm text-[#5e60ce] font-medium" target="_blank" rel="noopener noreferrer" data-id="element-461">
                      Launch Newsfiliate App
                    </a>
                  </div>}
              </div>
              <Link to="/" className="text-gray-600 hover:text-gray-900 font-medium px-2 py-1" onClick={() => setIsMenuOpen(false)} data-id="element-462">
                Creator Boost
              </Link>
              <a href="https://app.kit.com/apps/1229" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5e60ce] w-fit" style={{
            backgroundColor: '#5e60ce'
          }} target="_blank" rel="noopener noreferrer" data-id="element-463">
                Install on Kit
              </a>
            </div>
          </div>}
      </div>
    </header>;
}